import React, { useRef, useEffect, useMemo } from "react";
import Tween from "../tween/Tween";
import { connect } from "../../store";
import { decorateRichText } from "./utils";

function ItineraryPlaceEndCard({ dispatch, placeEndNodeByPlaceId, item }) {
    const ref = useRef();
    const text = item.text;
    const newText = useMemo(() => decorateRichText(text), [text]);

    useEffect(() => {
        dispatch({
            type: "ADD_TO_PLACE_END_NODE_BY_PLACE_ID",
            payload: {
                [item.place_id]: ref.current,
            },
        });
        return () => {
            dispatch({
                type: "SET_PLACE_END_NODE_BY_PLACE_ID",
                payload: Object.fromEntries(
                    Object.entries(placeEndNodeByPlaceId).filter(([key]) => key !== item.place_id),
                ),
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, ref, item.place_id]);

    return (
        <Tween
            className="trpr-itinerary-place-end-card-container"
            ref={ref}
            icon={""}
            type={"secondary"}
            singleLine={true}
            divider={"none"}
        >
            <div dangerouslySetInnerHTML={{ __html: newText }} />
        </Tween>
    );
}

const mapStateToProps = ({ placeEndNodeByPlaceId }) => ({ placeEndNodeByPlaceId });

export default connect(mapStateToProps)(ItineraryPlaceEndCard);
